import { v4 } from 'uuid'

export function generateUuid() {
  return v4()
}
